<script>
	import { isInViewport } from "../utils";

	export let options = [];
	export let value = null;

	// let activex;

	// $: console.log("activex", activex);

	// onMount(() => {
	// 	let container = document.querySelector(".buttons");
	// 	let links = document.querySelectorAll(".button");

	// 	var current = 0;
	// 	var next = 0;

	// 	const update = () => {
	// 		console.log("UPDATE");
	// 		if (next !== current) {
	// 			current = next;

	// 			for (var j = 0; j < links.length; j++) {
	// 				links[j].classList.remove("xactive");
	// 			}
	// 			links[current].classList.add("xactive");
	// 			activex = current;
	// 			container.scrollTo({
	// 				left: current === 0 ? 0 : links[current].offsetLeft - 10,
	// 				behavior: "smooth",
	// 			});
	// 		}
	// 	};

	// 	var threshold = 0.001;
	// 	var rootMargin = "0px 0px -50% 0px";
	// 	var options = { rootMargin: rootMargin, threshold: threshold };

	// 	for (var i = 0; i < links.length; i++) {
	// 		(function (i) {
	// 			// var target = document.querySelector(links[i].getAttribute('href'));
	// 			let target = links[i];
	// 			var observer = new IntersectionObserver(function (entries) {
	// 				console.log(entries);
	// 				if (entries[0].intersectionRatio > 0) {
	// 					next = i;
	// 					update();
	// 				}
	// 			}, options);
	// 			observer.observe(target);
	// 		})(i);
	// 	}
	// });
	let rightEnd = false;
	let leftEnd = true;

	const checkForGradient = () => {
		const difference = container.scrollLeft + container.offsetWidth - container.scrollWidth;
		rightEnd = difference > -1;
		leftEnd = container.scrollLeft < 1;
	};

	let container;
</script>

<div class="buttons-container">
	<div
		class="buttons"
		bind:this={container}
		on:scroll={() => {
			checkForGradient();
		}}
	>
		{#each options as o, j}
			{@const active = o.value === value}
			<div
				class="button"
				class:active
				class:sep={o.sep}
				class:presep={options[j + 1] && options[j + 1].sep}
				style:background-color={active ? o.color : null}
				style:scroll-snap-align={j <= (options.length - 1) / 2 ? "start" : j === options.length - 1 ? "end" : ""}
				bind:this={o.button}
				on:click={(e) => {
					value = o.value;
					if (!isInViewport(o.button))
						container.scrollTo({
							left: j === 0 ? 0 : o.button.offsetLeft - 10,
							behavior: "smooth",
						});
				}}
			>
				<slot option={o} active={o.value === value} />
			</div>
		{/each}
	</div>
	<div class="gradient left" class:hidden={leftEnd} />
	<div class="gradient right" class:hidden={rightEnd} />
</div>

<style lang="scss">
	@import "../main.scss";
	$btn-black: #1f1f1f;

	.buttons-container {
		position: relative;
	}

	.buttons {
		text-align: center;
		display: flex;
		flex-direction: row;
		text-align: center;
		overflow: hidden;
		width: fit-content;
		font-weight: $medium;

		@media (max-width: $breakpoint-tablet-s) {
			width: 100%;
			overflow-x: scroll;
			-webkit-overflow-scrolling: touch;
			scrollbar-width: none;
			-ms-overflow-style: none;
			scroll-snap-type: x mandatory;
			scroll-padding: 20px;
		}

		&::-webkit-scrollbar {
			display: none;
		}
	}

	.gradient {
		position: absolute;
		top: 0;
		width: 10%;
		height: 100%;
		pointer-events: none;
		transition: opacity 0.4s ease;

		&.right {
			right: 0;
			background-image: linear-gradient(to right, rgba(255, 255, 255, 0), rgba(255, 255, 255, 1));
		}

		&.left {
			left: 0;
			background-image: linear-gradient(to left, rgba(255, 255, 255, 0), rgba(255, 255, 255, 1));
		}

		&.hidden {
			opacity: 0;
		}
	}

	@media (min-width: #{$breakpoint-tablet-s + 1px}) {
		.gradient {
			display: none;
		}
	}

	.button {
		border: 1px solid #2a2a2a;
		position: relative;
		white-space: nowrap;
		user-select: none;
		-webkit-tap-highlight-color: transparent;
		cursor: pointer;
		transition: background-color 0.3s ease, color 0.3s ease;
		color: #2a2a2a;
		flex-grow: 1;

		@media (min-width: #{$breakpoint-tablet-s + 1px}) {
			padding: 4px 13px 4px 4px;
		}

		@media (max-width: $breakpoint-tablet-s) {
			padding: 4px 21px 4px 12px;
		}

		&:not(:last-child) {
			margin-right: -1px;
		}

		&.presep {
			border-radius: 0 1px 1px 0;
		}

		&.sep {
			margin-left: 10px;
			border-radius: 1px 0 0 1px;

			&:last-child {
				border-radius: 1px 1px 1px 1px;
			}
		}

		&:first-child {
			border-radius: 1px 0 0 1px;
		}

		&:last-child {
			border-radius: 0 1px 1px 0;
		}
	}

	.button.active {
		pointer-events: none;
		color: #000;
	}
</style>
